import React from "react";
import VerificationComponent from "../components/Verification";

const Verification = () => {
  return <VerificationComponent />;
};

export default Verification;
